import Portal from "elements/Portal";
import React from "react";
import { WEBSITE_BUILDER_PORTAL } from "pages/secure/facility/websiteBuilder/editor/WebsiteBuilderEditor";
import { WEBSITE_BUILDER_Z_LAYERS } from "pages/secure/facility/websiteBuilder/editor/utility/websiteBuilderZLayers";
import {
  BuilderSettingsSheet,
  IBuilderSettingsSheetProps,
} from "pages/secure/facility/builders/shared/components/settingsSheet/BuilderSettingsSheet";

export type IWebsiteBuilderSettingsSheetProps = IBuilderSettingsSheetProps;

export function WebsiteBuilderSettingsSheet(props: IWebsiteBuilderSettingsSheetProps) {
  return (
    <Portal isMounted={true} parentId={WEBSITE_BUILDER_PORTAL}>
      <div
        onMouseOver={e => e.stopPropagation()}
        onMouseOut={e => e.stopPropagation()}
        onDoubleClick={e => e.stopPropagation()}
        onPointerDown={e => e.stopPropagation()}
        onContextMenu={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
        style={{
          zIndex: WEBSITE_BUILDER_Z_LAYERS.portal,
        }}
      >
        <BuilderSettingsSheet {...props} />
      </div>
    </Portal>
  );
}
